<div class="w-full grid gap-4">
  <p class="text-base font-medium tracking-wider mb-0!">
    Trascina un file qui o clicca per caricare
  </p>
  <p class="text-sm mb-0!">Formati supportati: PDF, PNG, JPG – max 10MB</p>

  @if (!hideDrag) {
    <div
      tabindex="0"
      class="uploader-container bg-surface-container-high min-h-[180px] mb-2"
      [class.drag-active]="isDragging"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="openFilePicker()"
      (keypress)="openFilePicker()"
      >
      <input
        #fileInput
        type="file"
        class="hidden"
        [multiple]="true"
        [accept]="accept"
        [disabled]="control?.disabled"
        (change)="onFileSelected($event)"
        />

      <div class="text-center p-6">
        <mat-icon
          class="text-outline-variant material-icons-outlined"
          style="font-size: 180px; width: 180px; height: 180px"
          >
          file_upload
        </mat-icon>
      </div>
    </div>
  }
  <div class="flex items-center space-x-2 pt-4">
    <mat-form-field appearance="outline" class="grow">
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        [attr.id]="id"
        [attr.name]="name"
        [value]="fileNamesDisplay"
        placeholder="Nessun file selezionato"
        readonly
        />
      <mat-hint class="font-normal"
        >Formati supportati: PDF, PNG, JPG – max 10MB</mat-hint
        >
      </mat-form-field>

      <button
        mat-raised-button
        type="button"
        (click)="openFilePicker()"
        [disabled]="control?.disabled"
        class="shrink-0 text-primary mb-5"
        >
        <mat-icon class="material-icons-outlined"> file_upload </mat-icon>
        Scegli file
      </button>
    </div>

    @if (files.length > 0) {
      <div>
        <mat-list class="mt-0! pt-0! file-upload-list">
          @for (file of files; track file; let i = $index; let last = $last) {
            <mat-list-item>
              <div matListItemTitle class="flex justify-between items-center w-full">
                <div class="text-sm font-normal truncate pr-2">
                  {{ file.name }} ({{ formatBytes(file.size) }})
                </div>
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'Rimuovi file ' + file.name"
                  (click)="removeFile(file); $event.stopPropagation()"
                  [disabled]="control?.disabled"
                  >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                </button>
              </div>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </div>
